import configureStore from 'data/configureStore'

import notificationMiddleware from 'lib/notification-middleware'
import noteMiddleware from 'lib/note-middleware'

export default function createStore(config) {
  return configureStore({
    config,
    platformMiddleware: [notificationMiddleware, noteMiddleware],
  })
}
